import { MouseEvent, useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useAtom } from 'jotai';
import { Text } from '@pairy/pds-react';

import useUpdateViewerPageState from '../../../../../hooks/useUpdateViewerPageState';
import { isDisableHelpersAtom } from '../../../../../store/index.atom';

import * as Styled from './index.styles';

export interface Props {
  totalPage?: number;
  ctaFormPage?: number;
  isMoveCtaFormPageRequirements?: boolean;
}

interface Inputs {
  currentPage: number;
}

const DesktopPageIndicator = ({
  totalPage,
  ctaFormPage,
  isMoveCtaFormPageRequirements,
}: Props) => {
  const [isDisableHelpers, setIsDisableHelpers] = useAtom(isDisableHelpersAtom);

  const { updateCurrentPage, currentPage } = useUpdateViewerPageState();

  const handleClickWrapper = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }
  };

  const [isEditable, setIsEditable] = useState(false);
  const { handleSubmit, register, setFocus, setValue, getValues } =
    useForm<Inputs>();

  useEffect(() => {
    if (!isEditable) {
      setValue('currentPage', currentPage);
    }
  }, [currentPage, isEditable, setValue]);

  const changeCurrentPage = () => {
    const value = getValues('currentPage');

    if (totalPage && value >= 1 && value <= totalPage) {
      /*만일 폼을 제출해야만 뷰어의 내용을 보도록 설정한 상태에서 
      다른 페이지로 유저가 이동하려 한 경우에 폼 페이지로 이동시킨다 */
      if (
        ctaFormPage &&
        isMoveCtaFormPageRequirements &&
        Number(value) >= ctaFormPage
      ) {
        updateCurrentPage(ctaFormPage);
      } else {
        updateCurrentPage(Number(value));
      }
    }

    setIsEditable(false);
  };

  const onSubmit: SubmitHandler<Inputs> = () => {
    changeCurrentPage();
  };

  useEffect(() => {
    setIsEditable(false);
  }, [isDisableHelpers, setIsEditable]);

  useEffect(() => {
    if (isDisableHelpers) {
      changeCurrentPage();
    }
  }, [isDisableHelpers]);

  useEffect(() => {
    if (isEditable) {
      setFocus('currentPage');
    }
  }, [isEditable, setFocus]);

  return (
    <Styled.StackWrapper
      className={isDisableHelpers ? 'disable' : ''}
      alignItems="center"
      gap={8}
      onClick={handleClickWrapper}
    >
      {isEditable ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Styled.Input
            type="number"
            {...register('currentPage', {
              value: currentPage,
            })}
          />
        </form>
      ) : (
        <Styled.FlexCurrentPageTextWrapper
          alignContent="center"
          justifyContent="center"
          onClick={(e) => {
            e.stopPropagation();
            setIsDisableHelpers(false);
            setIsEditable(true);
          }}
        >
          <Text variant="md-medium" color="black">
            {currentPage}
          </Text>
        </Styled.FlexCurrentPageTextWrapper>
      )}
    </Styled.StackWrapper>
  );
};

export default DesktopPageIndicator;
